// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yhB-","input":"styles_input__2ZtmF"};